module.exports = __webpack_public_path__ + "img/sales.831f8868.svg";